const EventData = [

    {
        id: 1,
        eName: "The Anderson's Wedding",
        eDetails: "Join with John and Anna Anderson, and help them celebrate their union",
        location: "St Mary's Cathedral",
        created: "2019-22-04T16:00:01.250Z"

    },

    {
        id: 2,
        eName: "Caleb's 5th Birthday",
        eDetails: "Meet Spiderman and sing-a-long with Marvel Superheros at Caleb;s big day",
        location: "141 Happyside Road, Anywhere US",
        created: "2019-22-04T18:00:01.250Z"

    },


]

export default EventData